import React, { Fragment } from "react";
import { Routes, Route } from "react-router-dom";

import "./index.scss";
import { useData } from "./util/dataProvider";
import Login from "./components/Login";
import NewProfiSelect from "./components/NewProfiSelect";
import MyProfilSelect from "./components/MyProfilSelect";
import UnternehmensForm from "./components/UnternehmensForm";
import ExpertensForm from "./components/ExpertensForm";
import Password from "./components/Passwort";
import { useNavigate, useLocation } from "react-router-dom";
import VerifyEmail from "./components/VerifyEmail";

function App() {
    const { user, signOut } = useData();

    const navigate = useNavigate();
    const location = useLocation();
    return (
        <div className='App'>
            <div className='top-nav'>
                {location.pathname !== "/" ? (
                    <div
                        className='sign-out'
                        style={{ left: "10vw", marginBottom: 12 }}
                        onClick={() => navigate("/")}>
                        Startseite
                    </div>
                ) : (
                    <div></div>
                )}
                {user ? (
                    <div className='sign-out' onClick={() => signOut()}>
                        Abmelden
                    </div>
                ) : null}
            </div>
            {user ? (
                <Routes>
                    {user.emailVerified ? (
                        <Fragment>
                            <Route
                                exact
                                path='/newprofilselect'
                                element={<NewProfiSelect />}
                            />
                            <Route
                                exact
                                path='/myprofilselect'
                                element={<MyProfilSelect />}
                            />
                            <Route
                                exact
                                path='/unternehmensform'
                                element={<UnternehmensForm />}
                            />
                            <Route
                                exact
                                path='/expertensform'
                                element={<ExpertensForm />}
                            />

                            <Route path='/' element={<NewProfiSelect />} />
                        </Fragment>
                    ) : (
                        <Route path='/' element={<VerifyEmail />} />
                    )}
                </Routes>
            ) : (
                <Routes>
                    <Route exact path='/password' element={<Password />} />
                    <Route path='/' element={<Login />} />
                </Routes>
            )}
        </div>
    );
}

export default App;
